<div class="container-fluid" #top>
  <div class="row">
    <div class="col-md-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
    <div class="col-12">
      <!-- GENERAL -->
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px">General</span>
        <div class="rectangle-34"></div>
      </div>

      <img
        class="vector-4"
        src="../../../assets/img/border-color-13@2x.png"
        height="20"
        alt="Vector 4"
        class="pen-right"
        (click)="moveToCarrierType()"
        *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1"
      />

      <br />
      <div class="row">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Account Number:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.carrier_code
            }}</span>
          </div>
        </div>
        <!-- <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Account Id:</span>
          </div>
        </div> -->
        <!-- <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              carrierAccountObj.carrier_account_id
            }}</span>
          </div>
        </div> -->
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Account Status:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.carrier_status
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Registered By:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >{{ caConfirmObj.lead_user?.first_name }}&nbsp;{{
                caConfirmObj.lead_user?.last_name
              }}</span
            >
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Account Balance:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.account_balance
                ? (caConfirmObj.account_balance | currencyFormat)
                : "R0.00"
            }}</span>
          </div>
        </div>
        <div></div>

        <!-- <td class="s-td">
                            <b>Account Status:<span style="color: red;"> {{caConfirmObj.carrier_status}}</span></b>
                            </td> -->
        <!-- <td class="s-td">
                               <b class="td-in">First Name:</b><span class="m-cont text-primary">{{caConfirmObj.lead_user?.first_name}}</span>
                            </td>
                            <td class="s-td">
                              <b class="td-in">Last Name:</b><span class="m-cont text-primary">{{caConfirmObj.lead_user?.last_name}}</span>
                            </td> -->
      </div>

      <br />
      <br />
    </div>
    <div class="col-12">
      <!-- CARRIER ACCOUNT -->
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px">Carrier Account</span>
        <div class="rectangle-34"></div>
      </div>
      <img
        class="vector-4"
        src="../../../assets/img/border-color-13@2x.png"
        height="20"
        alt="Vector 4"
        class="pen-right"
        (click)="moveToCarrierType()"
        *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1"
      />

      <br />
      <!-- <label class="sb-txt" *ngIf="caConfirmObj.carrier_type_ind==6"><u></u></label> -->

      <div class="row">
        <!--1st row-->
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Customer Type:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.carrier_type
            }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Country:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.country
            }}</span>
          </div>
        </div>

        <div
          class="col-md-6"
          *ngIf="
            caConfirmObj.carrier_type_ind != 1 &&
            caConfirmObj.carrier_type_ind != 2
          "
        >
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Company Reg Name:</span>
          </div>
        </div>
        <div
          class="col-md-6"
          *ngIf="
            caConfirmObj.carrier_type_ind != 1 &&
            caConfirmObj.carrier_type_ind != 2
          "
        >
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.registered_name
            }}</span>
          </div>
        </div>

        <!--2nd row-->

        <div
          class="col-md-6"
          *ngIf="
            caConfirmObj.carrier_type_ind == 1 ||
            caConfirmObj.carrier_type_ind == 2
          "
        >
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Name:</span>
          </div>
        </div>
        <div
          class="col-md-6"
          *ngIf="
            caConfirmObj.carrier_type_ind == 1 ||
            caConfirmObj.carrier_type_ind == 2
          "
        >
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >{{ caConfirmObj.owner?.first_name }}&nbsp;{{
                caConfirmObj.owner?.last_name
              }}</span
            >
          </div>
        </div>

        <div
          class="col-md-6"
          *ngIf="
            caConfirmObj.carrier_type_ind != 1 &&
            caConfirmObj.carrier_type_ind != 2
          "
        >
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Trading Name:</span>
          </div>
        </div>
        <div
          class="col-md-6"
          *ngIf="
            caConfirmObj.carrier_type_ind != 1 &&
            caConfirmObj.carrier_type_ind != 2
          "
        >
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.trading_name
            }}</span>
          </div>
        </div>

        <div class="col-md-6" *ngIf="caConfirmObj.carrier_type_ind == 1">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">ID Number:</span>
          </div>
        </div>
        <div class="col-md-6" *ngIf="caConfirmObj.carrier_type_ind == 1">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.registration_number
            }}</span>
          </div>
        </div>

        <div class="col-md-6" *ngIf="caConfirmObj.carrier_type_ind == 2">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >Passport / ID Number:</span
            >
          </div>
        </div>
        <div class="col-md-6" *ngIf="caConfirmObj.carrier_type_ind == 2">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.registration_number
            }}</span>
          </div>
        </div>
      </div>

      <div
        *ngIf="
          caConfirmObj.carrier_type_ind != 1 &&
          caConfirmObj.carrier_type_ind != 2
        "
      >
        <!--3rd row-->

        <div class="row" *ngIf="caConfirmObj.carrier_type_ind == 6">
          <div class="col-md-6">
            <div class="trading-name opensans-normal-black-16px">
              <span class="opensans-normal-black-16px"
                >Closed Corporation Reg No:</span
              >
            </div>
          </div>

          <div class="col-md-6">
            <div class="number opensans-normal-black-16px">
              <span class="opensans-normal-black-16px">{{
                caConfirmObj.registration_number
              }}</span>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="caConfirmObj.carrier_type_ind == 7">
          <div class="col-md-6">
            <div class="trading-name opensans-normal-black-16px">
              <span class="opensans-normal-black-16px">Trust Reg No:</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="number opensans-normal-black-16px">
              <span class="opensans-normal-black-16px">{{
                caConfirmObj.registration_number
              }}</span>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="caConfirmObj.carrier_type_ind == 8">
          <div class="col-md-6">
            <div class="trading-name opensans-normal-black-16px">
              <span class="opensans-normal-black-16px"
                >ID Number of Main Partner:</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <div class="number opensans-normal-black-16px">
              <span class="opensans-normal-black-16px">{{
                caConfirmObj.registration_number
              }}</span>
            </div>
          </div>
        </div>
        <div
          class="row"
          *ngIf="
            caConfirmObj.carrier_type_ind != 6 &&
            caConfirmObj.carrier_type_ind != 1 &&
            caConfirmObj.carrier_type_ind != 2 &&
            caConfirmObj.carrier_type_ind != 7 &&
            caConfirmObj.carrier_type_ind != 8
          "
        >
          <div class="col-md-6">
            <div class="trading-name opensans-normal-black-16px">
              <span class="opensans-normal-black-16px">Company Reg No:</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="number opensans-normal-black-16px">
              <span class="opensans-normal-black-16px">{{
                caConfirmObj.registration_number
              }}</span>
            </div>
          </div>
        </div>
        <!-- <td>
                    <b class="td-in">Type of Business:</b><span class="m-cont text-primary">
                      <ng-container *ngFor="let list of utility.businessTypes">
                        <span *ngIf="list.key==caConfirmObj.business_type_ind">{{list.value}}</span>
                      </ng-container>
                    </span>
                  </td> -->
      </div>

      <div class="row" *ngIf="caConfirmObj.carrier_type_ind == 2">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >Passport Country-of-Issue:</span
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.country
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >Passport Expiry Date:</span
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.owner?.passport_expiry_date | date : "dd/MM/yyyy"
            }}</span>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="caConfirmObj.carrier_type_ind == 2">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >Traffic Register Number (TRN):</span
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.owner?.traffic_register_number
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >Work Permit Reference Number:</span
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.owner?.work_permit_number
            }}</span>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="caConfirmObj.carrier_type_ind == 2">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">TRN Date-of-Issue:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.owner?.trn_issue_date | date : "dd/MM/yyyy"
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >Work Permit Expiry Date:</span
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.owner?.work_permit_expiry_date | date : "dd/MM/yyyy"
            }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Type of Carrier:</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">
              <ng-container *ngFor="let list of utility.freight_passenger_inds">
                <span *ngIf="list.key == caConfirmObj.freight_passenger_ind">{{
                  list.value
                }}</span>
              </ng-container>
            </span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Email Address:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.email
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Mobile Number:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >{{ caConfirmObj.dial_code_mobile }}&nbsp;{{
                caConfirmObj.mobile
              }}</span
            >
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Office Number:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >{{ caConfirmObj.dial_code_office_phone }}&nbsp;{{
                caConfirmObj.office_phone
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <div
      class="col-md-12"
      *ngIf="caConfirmObj.main_company || caConfirmObj.subsidiaries?.length > 0"
      style="margin-bottom: 10px"
    >
      <br />
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px"
          >Main and Subsidiaries Companies</span
        >
        <div class="rectangle-34"></div>
      </div>
      <br />
      <div class="row" *ngIf="caConfirmObj.main_company">
        <div class="col-md-12">
          <h3>Main Company Details</h3>
        </div>

        <div class="col-md-6">Account Number</div>
        <div class="col-md-6">
          {{ caConfirmObj.main_company.account_number }}
        </div>

        <div class="col-md-6">Account Name</div>
        <div class="col-md-6">
          {{ caConfirmObj.main_company.account_name }}
        </div>

        <div class="col-md-6">Trading Name</div>
        <div class="col-md-6">
          {{ caConfirmObj.main_company.trading_name }}
        </div>

        <div class="col-md-6">Registration Number</div>
        <div class="col-md-6">
          {{ caConfirmObj.main_company.reg_number }}
        </div>
      </div>
      <div class="row" *ngIf="caConfirmObj.subsidiaries?.length > 0">
        <div class="col-md-12">
          <h3>Subsidiaries</h3>
          <br />
        </div>
        <div class="col-md-12">
          <app-subsidiary-list-companies
            [listAccounts]="caConfirmObj.subsidiaries"
          ></app-subsidiary-list-companies>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <br />
    </div>
    <!-- CONTACT DETAILS -->
    <div class="col-md-12">
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px">Contact Details</span>
        <div class="rectangle-34"></div>
      </div>
      <br />
      <img
        class="vector-4"
        src="../../../assets/img/border-color-13@2x.png"
        height="20"
        alt="Vector 4"
        class="pen-right"
        (click)="moveToContact()"
        *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1"
      />

      <div class="row">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Name:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >{{ caConfirmObj.contact?.first_name }}&nbsp;{{
                caConfirmObj.contact?.last_name
              }}</span
            >
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Email:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.contact?.email
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Mobile:</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >{{ caConfirmObj.contact?.dial_code_mobile }}&nbsp;{{
                caConfirmObj.contact?.mobile
              }}</span
            >
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >Communication Preference:</span
            >
          </div>
        </div>

        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.contact?.comms_preference
            }}</span>
          </div>
        </div>

        <br />
        <br />
        <br />
        <div class="col-12">
          <div class="address-1 opensans-semi-bold-sapphire-30px">
            <span class="opensans-semi-bold-sapphire-30px">Address</span>
            <div class="rectangle-34"></div>
          </div>
          <img
            class="vector-4"
            src="../../../assets/img/border-color-13@2x.png"
            height="20"
            alt="Vector 4"
            class="pen-right"
            (click)="moveToAddress()"
            *ngIf="
              utility.isView && !utility.isCarrier && ctrlData.xstatus != 1
            "
          />

          <br />
        </div>

        <br />
        <br />
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Physical Address:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">
              {{ caConfirmObj.physical_address?.line_address_1 }}
              {{ caConfirmObj.postal_address?.line_address_1 }}</span
            >
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Town:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.physical_address?.line_address_town
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Post Code:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.physical_address?.line_post_code
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <br />
    </div>
    <!-- COMPLIANCE AND LEGAL -->
    <div class="col-12">
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px"
          >Compliance and Legal</span
        >
        <div class="rectangle-34"></div>
      </div>
      <img
        class="vector-4"
        src="../../../assets/img/border-color-13@2x.png"
        height="20"
        alt="Vector 4"
        class="pen-right"
        (click)="moveToComplance()"
        *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1"
      />

      <br />
      <div *ngIf="caConfirmObj.is_local == 1" class="row">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Tax Number:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.tax_number
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >Transport Association:</span
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.transport_assoc
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- DEMOGRAPHICS -->
    <div class="col-12">
      <br />
    </div>
    <!-- <div class="col-12" *ngIf="caConfirmObj.bbbee_status!=''"> -->
    <div class="col-12" *ngIf="caConfirmObj.is_local">
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px">Demographics</span>
        <div class="rectangle-34"></div>
      </div>
      <img
        class="vector-4"
        src="../../../assets/img/border-color-13@2x.png"
        height="20"
        alt="Vector 4"
        class="pen-right"
        (click)="moveToDemo()"
        *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1"
      />
      <br />
      <div class="row">
        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">BBBEE Status:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.bbbee_status
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >BBBEE Certificate Expiry Date:</span
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.Demographic.BBBEE_cert_expiry_date
                | date : "dd/MM/yyyy"
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">% Black Ownership:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.Demographic.black_ownership_percentage
            }}</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">% Female Ownership:</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.Demographic.female_ownership_percentage
            }}</span>
          </div>
        </div>
        <br />
        <br />
        <div class="col-md-6" style="padding-top: 20px">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px"
              >% Disability Ownership:</span
            >
          </div>
        </div>
        <div class="col-md-6" style="padding-top: 20px">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.Demographic.disability_ownership_percentage
            }}</span>
          </div>
        </div>

        <div class="col-md-6" style="padding-top: 20px">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">% Youth Ownership:</span>
          </div>
        </div>
        <div class="col-md-6" style="padding-top: 20px">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.Demographic.youth_ownership_percentage
            }}</span>
          </div>
        </div>

        <div class="col-md-6" style="padding-top: 20px">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Turnover Brand:</span>
          </div>
        </div>
        <div class="col-md-6" style="padding-top: 20px">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              turnOverBrand[caConfirmObj.Demographic["turnover_band"]]
            }}</span>
          </div>
        </div>

        <div class="col-md-6" style="padding-top: 20px">
          <div class="trading-name opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">Number of Employees:</span>
          </div>
        </div>
        <div class="col-md-6" style="padding-top: 20px">
          <div class="number opensans-normal-black-16px">
            <span class="opensans-normal-black-16px">{{
              caConfirmObj.Demographic.number_of_employees
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <br />
    </div>

    <!-- DOCUMENTS -->
    <div class="col-12">
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px">Documents Uploaded</span>
        <div class="rectangle-34"></div>
      </div>
      <img
        class="vector-4"
        src="../../../assets/img/border-color-13@2x.png"
        height="20"
        alt="Vector 4"
        class="pen-right"
        (click)="gotoDocs()"
        *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1"
      />

      <br />
      <label class="sb-txt"><u></u></label>
      <div class="row">
        <div class="col-12">
          <app-document-viewer
            [uploadedDocs]="caConfirmObj?.documents"
          ></app-document-viewer>
        </div>
      </div>
    </div>

    <!-- displyQuestionere -->
    <div class="col-12">
      <div class="contact-details opensans-semi-bold-sapphire-30px">
        <span class="opensans-semi-bold-sapphire-30px">OCAS</span>
        <div class="rectangle-34"></div>
      </div>
      <img
        class="vector-4"
        src="../../../assets/img/border-color-13@2x.png"
        height="20"
        alt="Vector 4"
        class="pen-right"
        (click)="back()"
        *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1"
      />

      <br />
      <!-- start Tabs -->
      <div class="container-fluid">
        <ul class="nav nav-tabs" style="display: table; width: 100%">
          
          <li class="nav-item col-md-4" style="display: table-cell;width: 70px">
            <a
              (click)="selectedTab = 0"
              class="nav-link active"
              style="text-align: center"
              role="tab"
              data-toggle="tab"
              >Depots</a
            >
          </li>
          <li class="nav-item col-md-4" style="display: table-cell;width: 70px">
            <a
              (click)="selectedTab = 1"
              class="nav-link"
              style="text-align: center"
              role="tab"
              data-toggle="tab"
              >Drivers</a
            >
          </li>
          <li class="nav-item col-md-4" style="display: table-cell;width: 70px">
            <a
              (click)="selectedTab = 2"
              class="nav-link"
              style="text-align: center"
              role="tab"
              data-toggle="tab"
              >Vehicles</a
            >
          </li>
          <li class="nav-item col-md-4" style="display: table-cell;width: 70px;">
            <a
              (click)="selectedTab = 3"
              style="text-align: center"
              class="nav-link "
              aria-current="page"
              aria-controls="one"
              role="tab"
              data-toggle="tab"
              >OCAS Questionnaire</a
            >
          </li>
          <li class="nav-item col-md-4" style="display: table-cell;width: 70px" *ngIf="!isExternalRole">
            <a
              (click)="selectedTab = 4"
              class="nav-link"
              style="text-align: center"
              role="tab"
              data-toggle="tab"
              >OCAS Audit</a
            >
          </li>
        </ul>
        <div class="tab-content">
          <div
            *ngIf="selectedTab === 3"
            role="tabpanel"
            class="tab-pane active"
            id="one"
          >
            <app-display-questionnaire
              [data]="ocasCarrierId"
            ></app-display-questionnaire>
          </div>

          <div
            *ngIf="selectedTab === 0"
            role="tabpanel"
            class="tab-pane active"
            id="0"
          >
            <app-display-carrier-depot
              [data]="ocasCarrierId"
            ></app-display-carrier-depot>
          </div>
          <div
            *ngIf="selectedTab === 1"
            role="tabpanel"
            class="tab-pane active"
            id="1"
          >
            <app-display-carrier-driver
              [data]="ocasCarrierId"
            ></app-display-carrier-driver>
          </div>
          <div
            *ngIf="selectedTab === 2"
            role="tabpanel"
            class="tab-pane active"
            id="2"
          >
            <app-display-manage-vehicles
              [carrireAccountNumber]="accountNumber"
              [data]="ocasCarrierId"
            ></app-display-manage-vehicles>
          </div>
          <div
            *ngIf="selectedTab === 4"
            role="tabpanel"
            class="tab-pane active"
            id="two"
          >
            <app-ocas-audit
            ></app-ocas-audit>
          </div>
        </div>
      </div>

      <!-- End Tabs -->
    </div>

    <div class="col-12" *ngIf="isExternalRole">
      <div *ngIf="!ctrlData.isApproval">
        <!-- <label class="sb-txt">Carrier account declaration</label> - -->
        <div class="row">
          <div class="col-12">
            <div class="contact-details opensans-semi-bold-sapphire-30px">
              <span class="opensans-semi-bold-sapphire-30px">Declaration</span>
            </div>
            <div class="rectangle-34"></div>
            <br />

            <p
              class="declaration-by-john-doe-on-01012022 opensans-semi-bold-black-20px-2"
            >
              <span class="opensans-semi-bold-black-20px-2">
                Declaration by {{ userInfo.username }} on
                {{ decl_date | date : "dd/MM/yyyy" }}</span
              >
            </p>

            <form
              class="frm-top col-12"
              [formGroup]="form"
              (ngSubmit)="onSubmit(form.value)"
            >
              <label
                class="form-inline text-primary"
                style="margin: 0px; padding: 0px"
              >
                <input
                  [disabled]="isExternalRole"
                  class="form-control input-sm"
                  type="checkbox"
                  ([ngModel])="(termsFlag)"
                  id="uAgreed"
                  name="uAgreed"
                  (click)="checkTerms($event)"
                  formControlName="termsFlag"
                  required
                />
                <span class="opensans-normal-red-20px-2"
                  >&nbsp; &nbsp; By checking the box, you declare that you agree
                  with the declaration above?</span
                >
              </label>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 no-mp" *ngIf="utility.isBtnVisible">
      <!-- <button *ngIf="utility.isView && !utility.isCarrier && ctrlData.xstatus != 1" title="Previous tab"
        (click)="back()" type="submit" id="btnSave" class="btn btn-md m-clr hd-btn"
        >Back
      </button> -->
      <button
        *ngIf="utility.isView"
        title="Cancel"
        (click)="close()"
        type="submit"
        id="btnSave"
        class="btn btn-md m-clr hd-btn-close"
      >
        Close
      </button>
      <!-- <button title="Cancel" *ngIf="!hideBackButton" (click)="goBack()" type="button" id="btnBack"
              class="btn btn-md m-clr  hd-btn">Back
      </button> -->
      <button
        *ngIf="ctrlData.xstatus != 1 && isExternalRole"
        title="{{ submitTitle }}"
        (click)="onSubmit(form.value)"
        [disabled]="!this.termsFlag || !this.form.valid"
        type="submit"
        id=""
        class="btn btn-md m-clr hd-btn"
      >
        {{ submitButtonText }}
      </button>
    </div>
  </div>
</div>
<button
  id="btnView"
  class="btn btn-primary"
  style="width: 0px; visibility: hidden"
  aria-hidden="true"
  data-toggle="modal"
  data-target="#exampleModalLong"
></button>
<div
  class="modal fade"
  id="exampleModalLong"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-lg"
    style="min-height: 500px !important"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Document Uploaded
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-lg">
        <img *ngIf="isPDF == 2" [src]="doc" width="780" />
        <pdf-viewer
          *ngIf="isPDF == 1"
          [src]="doc"
          [render-text]="true"
          style="display: block"
          [original-size]="false"
          [autoresize]="true"
        ></pdf-viewer>
        <ngx-loading [show]="isLoadingImg"></ngx-loading>
      </div>
      <div class="modal-footer float-right" style="min-height: 25px !important">
        <button
          type="button"
          class="btn btn-md m-clr hd-btn mr-2 mt-2"
          data-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
